import { pageSizes } from "../constants/_constant";

export const calculatePercentage = (pageSize, valueCm) => {
  // Check if the provided page size is valid
  if (!(pageSize in pageSizes)) {
    return "Invalid page size";
  }

  // Get the dimensions of the selected page size
  const { width: pageWidth, height: pageHeight } = pageSizes[pageSize];

  // Calculate percentage of valueCm relative to page size
  const widthPercentage = Math.round(
    (Number(valueCm) / Number(pageWidth)) * 100
  );
  const heightPercentage = Math.round(
    (Number(valueCm) / Number(pageHeight)) * 100
  );

  return {
    widthPercentage: widthPercentage,
    heightPercentage: heightPercentage,
  };
};
